import React, { useEffect } from 'react';
import MyAccount from 'components/commercetools-ui/organisms/account/my-account';
import NavigationMenu from 'components/commercetools-ui/organisms/NavigationMenu';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';
import { useAccount } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';
import { useRouter } from 'next/navigation';
import Spinner from 'components/commercetools-ui/organisms/spinner';

const MyAccountTastic = ({ data }: TasticProps<any>) => {
  const [isDesktopSize] = useMediaQuery(desktop);
  const { loggedIn, account } = useAccount();
  const router = useRouter();

  useEffect(() => {
    if (!loggedIn) {
      router.replace('/');
    }

    if (!account?.firstName) {
      router.replace('/company-registration');
    }
  }, [loggedIn]);

  return loggedIn && account?.firstName ? (
    <div className="items-left my-[40px] flex flex-row justify-between gap-[60px] px-[20.5px] sm:px-24 sm:pt-0 md:pt-16  lg:px-48 xl:px-60 xl:pt-16 2xl:pt-32 3xl:px-80 3xl:pb-16">
      {isDesktopSize && <NavigationMenu loggedIn={loggedIn} />}
      <MyAccount {...data} />
    </div>
  ) : (
    <Spinner />
  );
};

export default MyAccountTastic;
